import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ToastService } from '../../services/toast.service';

/**
 * Displays toast notifications managed by the shared toast service.
 * This standalone component listens to the toast state exposed by
 * `ToastService` and renders the currently visible notifications.
 * It also provides functionality to dismiss individual toast messages.
 */
@Component({
  selector: 'zba-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  /**
   * Shared service responsible for managing toast notification state,
   * displaying notifications, and handling their lifecycle.
   */
  private readonly toastService = inject(ToastService);

  /**
   * Read-only signal containing the currently visible toast notifications.
   * The signal is obtained directly from `ToastService`, allowing the
   * component template to reactively update whenever the toast state changes.
   */
  public readonly toasts = this.toastService.toasts;

  /**
   * Dismisses a selected toast notification.
   * Delegates the dismissal operation to the shared `ToastService`.
   * @param id Unique identifier of the toast notification to dismiss.
   */
  public dismiss(id: number): void {
    this.toastService.dismiss(id);
  }
}